import { View } from "@lernetz/ts-lib";
import { translate } from "@lernetz/ts-lib/src/Lang";
import { Image as BaseImage } from "@lernetz/ui-components/src/image/Image";
import template from './Image.html';

export class Image extends BaseImage {

    caption: string;
    image: any;
    widthStyle: any;
    preset: string = 'large';

    constructor( dto ) {
        super( dto );
    }

    get height() {
        return this.image.height;
    };
    get width() {
        return this.image.width;
    }

}

export class ImageView extends View<Image> {

    constructor() {
        super( {
            template: template
        } );
    }

    init() {
        if( !this.data.image ) {
            let message = translate( 'no-image' );
            this.node.querySelector( 'img' ).setAttribute( 'src', 'https://via.placeholder.com/960x540.png?text=' + message );
        }
    }

}
